export default __webpack_public_path__ + "static/media/nav-dashboard.b02796b4.svg";